export default "__VITE_ASSET__CoJBgt4L__"